import { Card, CardContent, CardHeader, IconButton, Tooltip, Typography } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Form from './Form';

const AddBendahara = () => {
    const navigate = useNavigate();

    return (
        <Card>
            <CardHeader
                title={
                    <Typography variant='h5'>Input Bendahara</Typography>
                }
                avatar={
                    <Tooltip title="Kembali">
                        <IconButton variant="outlined" onClick={() => {
                            navigate("/admin/bendahara", { replace: true })
                        }} color="error"><ArrowBackIcon /></IconButton>
                    </Tooltip>
                }
            // subheader="September 14, 2016"
            />
            <CardContent>
                <Form />
            </CardContent>
        </Card>
    )
}

export default AddBendahara